import CampusStipendBrochure from "./CampusStipendBrochure"

export default function CampusBrochureVIT() {
    return <CampusStipendBrochure college="VIT Vellore" eligibility="2nd or 3rd-year undergrad" campus="vit" />
}
